<template>
	<div class='pollutions'>
		<div class='grid'>
			<div :class='{ "not-match": !isMatch(values["is_industrial_waste"]) }'>
				<custom-p-checkbox v-model='values["is_industrial_waste"].value' label='Промышленными' :disabled='!actLpoIsDraft'/>
			</div>
			<div :class='{ "not-match": !isMatch(values["is_household_waste"]) }'>
				<custom-p-checkbox v-model='values["is_household_waste"].value' label='Бытовыми' :disabled='!actLpoIsDraft'/>
			</div>
		</div>

		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>

		<div v-if='showPollutionList' class='flex-container pollution-list'>
			<div class='add-block'>
				<div>
					<span class='label'>Вид</span>
					<custom-p-select
						v-model='pollutionValue.pollution'
						:options='info_pollution'
						:disabled='!actLpoIsDraft'
					/>
				</div>
				<div class='label'>
					<span>Длина</span>
					<custom-p-input v-model='pollutionValue.length' type='number' :disabled='!actLpoIsDraft'/>
				</div>
				<div class='label'>
					<span>Ширина</span>
					<custom-p-input v-model='pollutionValue.width' type='number' :disabled='!actLpoIsDraft'/>
				</div>
				<div class='label'>
					<span>Высота</span>
					<custom-p-input v-model='pollutionValue.height' type='number' :disabled='!actLpoIsDraft'/>
				</div>
				
				<button @click='addPollution' :disabled='!actLpoIsDraft'>Добавить</button>
			</div>

			<div v-if='!pollutionList.length'>
				<span>Загрязнения еще не добавлены</span>
			</div>

			<div v-else class='table-container flex-item'>
				<table class='table-common'>
					<thead>
						<tr>
							<th>Вид загрязнения</th>
							<th>Длина, м</th>
							<th>Ширина, м</th>
							<th>Высота, м</th>
							<th>Объем, м3</th>
							<th>Площадь, га</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for='pollution in pollutionList'>
							<td>{{ pollution.pollution }}</td>
							<td>{{ pollution.pollution_l }}</td>
							<td>{{ pollution.pollution_w }}</td>
							<td>{{ pollution.pollution_h }}</td>
							<td>{{ pollution.pollution_v }}</td>
							<td>{{ pollution.pollution_s }}</td>
							<td>
								<button @click='removePollution(pollution)' :disabled='!actLpoIsDraft'>удалить</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'InspectionPollutions',
		data() {
			return {
				pollutionValue: {
					pollution: null,
					length: null,
					width: null,
					height: null
				},

				is_household_waste: false,
				is_industrial_waste: false,

				values: {
					is_household_waste: {
						field: 'is_household_waste',
						inputType: 'checkbox',
						value: false,
					},

					is_industrial_waste: {
						field: 'is_industrial_waste',
						inputType: 'checkbox',
						value: false,
					}
				}

			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			showPollutionList() {
				return this.lpo.is_industrial_waste === 't' || this.lpo.is_household_waste === 't';
			},

			...mapState('selectedLpo', {
				lpo: state => state['lpo'],
				pollutionList: state => state['pollutionList']
			}),

			info_pollution() {
				return this.$store.state.catalogs['info_pollution'];
			}
		},
		methods: {
			addPollution() {
				this.$store.dispatch('selectedLpo/addPollution', this.pollutionValue).then(res => {
					this.$store.dispatch('selectedLpo/updatePollutionList');
				});
			},

			removePollution(pollution) {
				this.$store.dispatch('selectedLpo/removePollution', pollution).then(res => {
					this.$store.dispatch('selectedLpo/updatePollutionList');
				});
			},

			save() {
				const valueList = [];

				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const temp = {
						field: this.values[value_name].field,
						value: inputTypeIsSelect ? this.values[value_name].value.id : this.values[value_name].value
					};
					valueList.push(temp);
				}

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				});

			},
			cancel() {
				this.resetValues();
			},
			resetValues() {
				this.values.is_household_waste.value = this.lpo.is_household_waste === 't' ? true : false;
				this.values.is_industrial_waste.value = this.lpo.is_industrial_waste === 't' ? true : false;
			},

			isMatch(value) {
				if (value.inputType === 'checkbox') {
					return value.value === (this.lpo[value.field] === 't');
				}

				return false;
			},

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},
		created() {
			const catalogs = [ 'info_pollution' ];
			this.$store.dispatch('loadCatalogs', catalogs).then(res => {
				this.resetValues();
			});
		}
	};
</script>

<style scoped src='@/style/flex.css'></style>
<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/table.css'></style>
<style scoped src='@/style/button.css'></style>
<style scoped src='@/style/input.css'></style>

<style scoped>
	.not-match {
		background-color: orange;
	}

	.add-block {
		border: 1px solid #ccc;
		padding: 10px;
		background-color: #eee;
		width: 300px;
	}

	.add-block > div {
		margin-bottom: 20px;
	}
	.add-block .label {
		font-weight: bold;
	}

	.flex-container {
		gap: 20px;
	}

	.pollution-list {
		margin-top: 30px;
	}
</style>